/**
 * React Query v4 Configuration
 * Centralized configuration for caching, retries, and stale time
 * Used across LeadsV2, TasksV2, BillingV2, and App.js
 *
 * Note: Query keys for global hooks are in src/hooks/config/queryClient.js
 */

import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 2 minutes before considering it stale
      staleTime: 2 * 60 * 1000,
      // Keep unused data in cache for 10 minutes (gcTime replaces cacheTime in v4+)
      gcTime: 10 * 60 * 1000,
      // Retry failed requests with smart logic
      retry: (failureCount, error) => {
        // Don't retry on 4xx errors (client errors)
        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false;
        }
        return failureCount < 2;
      },
      // Disable refetch on window focus for Kanban board (reduces unnecessary API calls)
      refetchOnWindowFocus: false,
      // Don't refetch on reconnect by default
      refetchOnReconnect: false,
      // Only refetch on mount if data is stale
      refetchOnMount: 'stale',
    },
    mutations: {
      // Retry failed mutations once
      retry: 1,
    },
  },
});
